import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-215ca93f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "t-cell-border__top"
}
const _hoisted_2 = {
  key: 0,
  class: "t-cell-group"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "t-cell-group t-cell-group__right"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "t-cell-row" }
const _hoisted_7 = {
  key: 0,
  class: "t-cell-group"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "t-cell-group t-cell-group__right"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "t-cell-row" }
const _hoisted_12 = { class: "t-cell-left" }
const _hoisted_13 = {
  key: 0,
  class: "t-cell-group"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "t-cell-right" }
const _hoisted_16 = {
  key: 0,
  class: "t-cell-group t-cell-group__right"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 3,
  class: "t-cell-badge"
}
const _hoisted_19 = {
  key: 0,
  class: "t-cell-badge_dotted"
}
const _hoisted_20 = {
  key: 1,
  class: "t-cell-badge_value"
}
const _hoisted_21 = {
  key: 5,
  class: "t-cell-border__bot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_icon = _resolveComponent("t-icon")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: _ctx.baseLayoutClasses.wrap
  }, _ctx.$attrs, {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
  }), [
    (_ctx.hasTopBorder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.$slots.extraBefore)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.baseLayoutClasses.cntBefore)
        }, [
          _renderSlot(_ctx.$slots, "extraBefore", {}, undefined, true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.prefix)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.baseLayoutClasses.prefix)
        }, [
          _renderSlot(_ctx.$slots, "prefix", {}, undefined, true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.baseLayoutClasses.content)
    }, [
      (_ctx.isOnlyLeft || _ctx.isOnlyRight)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.onlyClasses.wrap)
          }, [
            _renderSlot(_ctx.$slots, "leftTitle", {}, () => [
              (_ctx.hasLeftTitleImage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.leftTitleIcon)
                      ? (_openBlock(), _createBlock(_component_t_icon, {
                          key: 0,
                          "icon-name": _ctx.leftTitleIcon,
                          size: "xsmall",
                          class: "t-cell-icon"
                        }, null, 8, ["icon-name"]))
                      : _createCommentVNode("", true),
                    (_ctx.leftTitleImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.leftTitleImage,
                          class: "t-cell-img"
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (_ctx.leftTitle)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(_ctx.onlyClasses.leftTitle),
                          style: _normalizeStyle(_ctx.stylesByLeft)
                        }, _toDisplayString(_ctx.leftTitle), 7))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.hasLeftTitleImage && _ctx.leftTitle)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.onlyClasses.leftTitle),
                    style: _normalizeStyle(_ctx.stylesByLeft)
                  }, _toDisplayString(_ctx.leftTitle), 7))
                : _createCommentVNode("", true)
            ], true),
            _renderSlot(_ctx.$slots, "leftLabel", {}, () => [
              (_ctx.leftLabel)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(_ctx.onlyClasses.leftLabel),
                    style: _normalizeStyle(_ctx.stylesByLeft)
                  }, _toDisplayString(_ctx.leftLabel), 7))
                : _createCommentVNode("", true)
            ], true),
            _renderSlot(_ctx.$slots, "rightTitle", {}, () => [
              (_ctx.hasRightTitleImage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_ctx.rightTitleIcon)
                      ? (_openBlock(), _createBlock(_component_t_icon, {
                          key: 0,
                          "icon-name": _ctx.rightTitleIcon,
                          size: "xsmall",
                          class: "t-cell-icon"
                        }, null, 8, ["icon-name"]))
                      : _createCommentVNode("", true),
                    (_ctx.rightTitleImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.rightTitleImage,
                          class: "t-cell-img"
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    (_ctx.rightTitle)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(_ctx.onlyClasses.rightTitle),
                          style: _normalizeStyle(_ctx.stylesByRight)
                        }, _toDisplayString(_ctx.rightTitle), 7))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.hasRightTitleImage && _ctx.rightTitle)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.onlyClasses.rightTitle),
                    style: _normalizeStyle(_ctx.stylesByRight)
                  }, _toDisplayString(_ctx.rightTitle), 7))
                : _createCommentVNode("", true)
            ], true),
            _renderSlot(_ctx.$slots, "rightLabel", {}, () => [
              (_ctx.rightLabel)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(_ctx.onlyClasses.rightLabel),
                    style: _normalizeStyle(_ctx.stylesByRight)
                  }, _toDisplayString(_ctx.rightLabel), 7))
                : _createCommentVNode("", true)
            ], true)
          ], 2))
        : (_ctx.isMultiLineByBoth)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.bothClasses.wrap)
            }, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "leftTitle", {}, () => [
                  (_ctx.hasLeftTitleImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_ctx.leftTitleIcon)
                          ? (_openBlock(), _createBlock(_component_t_icon, {
                              key: 0,
                              "icon-name": _ctx.leftTitleIcon,
                              size: "xsmall",
                              class: "t-cell-icon"
                            }, null, 8, ["icon-name"]))
                          : _createCommentVNode("", true),
                        (_ctx.leftTitleImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.leftTitleImage,
                              class: "t-cell-img"
                            }, null, 8, _hoisted_8))
                          : _createCommentVNode("", true),
                        (_ctx.leftTitle)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: _normalizeClass(_ctx.bothClasses.leftTitle)
                            }, _toDisplayString(_ctx.leftTitle), 3))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.hasLeftTitleImage && _ctx.leftTitle)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(_ctx.bothClasses.leftTitle),
                        style: _normalizeStyle(_ctx.stylesByLeft)
                      }, _toDisplayString(_ctx.leftTitle), 7))
                    : _createCommentVNode("", true)
                ], true),
                _renderSlot(_ctx.$slots, "rightTitle", {}, () => [
                  (_ctx.hasRightTitleImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.rightTitleIcon)
                          ? (_openBlock(), _createBlock(_component_t_icon, {
                              key: 0,
                              "icon-name": _ctx.rightTitleIcon,
                              size: "xsmall",
                              class: "t-cell-icon"
                            }, null, 8, ["icon-name"]))
                          : _createCommentVNode("", true),
                        (_ctx.rightTitleImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.rightTitleImage,
                              class: "t-cell-img"
                            }, null, 8, _hoisted_10))
                          : _createCommentVNode("", true),
                        (_ctx.rightTitle)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: _normalizeClass(_ctx.bothClasses.rightTitle)
                            }, _toDisplayString(_ctx.rightTitle), 3))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.hasRightTitleImage && _ctx.rightTitle)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(_ctx.bothClasses.rightTitle),
                        style: _normalizeStyle(_ctx.stylesByRight)
                      }, _toDisplayString(_ctx.rightTitle), 7))
                    : _createCommentVNode("", true)
                ], true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "leftLabel", {}, () => [
                  (_ctx.leftLabel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.bothClasses.leftLabel),
                        style: _normalizeStyle(_ctx.stylesByLeft)
                      }, _toDisplayString(_ctx.leftLabel), 7))
                    : _createCommentVNode("", true)
                ], true),
                _renderSlot(_ctx.$slots, "rightLabel", {}, () => [
                  (_ctx.rightLabel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.bothClasses.rightLabel),
                        style: _normalizeStyle(_ctx.stylesByRight)
                      }, _toDisplayString(_ctx.rightLabel), 7))
                    : _createCommentVNode("", true)
                ], true)
              ])
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_ctx.multiClasses.wrap)
            }, [
              _createElementVNode("div", _hoisted_12, [
                _renderSlot(_ctx.$slots, "leftTitle", {}, () => [
                  (_ctx.hasLeftTitleImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_ctx.leftTitleIcon)
                          ? (_openBlock(), _createBlock(_component_t_icon, {
                              key: 0,
                              "icon-name": _ctx.leftTitleIcon,
                              size: "xsmall",
                              class: "t-cell-icon"
                            }, null, 8, ["icon-name"]))
                          : _createCommentVNode("", true),
                        (_ctx.leftTitleImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.leftTitleImage,
                              class: "t-cell-img"
                            }, null, 8, _hoisted_14))
                          : _createCommentVNode("", true),
                        (_ctx.leftTitle)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: _normalizeClass(_ctx.multiClasses.leftTitle),
                              style: _normalizeStyle(_ctx.stylesByLeft)
                            }, _toDisplayString(_ctx.leftTitle), 7))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.hasLeftTitleImage && _ctx.leftTitle)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(_ctx.multiClasses.leftTitle),
                        style: _normalizeStyle(_ctx.stylesByLeft)
                      }, _toDisplayString(_ctx.leftTitle), 7))
                    : _createCommentVNode("", true)
                ], true),
                _renderSlot(_ctx.$slots, "leftLabel", {}, () => [
                  (_ctx.leftLabel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.multiClasses.leftLabel),
                        style: _normalizeStyle(_ctx.stylesByLeft)
                      }, _toDisplayString(_ctx.leftLabel), 7))
                    : _createCommentVNode("", true)
                ], true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _renderSlot(_ctx.$slots, "rightTitle", {}, () => [
                  (_ctx.hasRightTitleImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_ctx.rightTitleIcon)
                          ? (_openBlock(), _createBlock(_component_t_icon, {
                              key: 0,
                              "icon-name": _ctx.rightTitleIcon,
                              size: "xsmall",
                              class: "t-cell-icon"
                            }, null, 8, ["icon-name"]))
                          : _createCommentVNode("", true),
                        (_ctx.rightTitleImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.rightTitleImage,
                              class: "t-cell-img"
                            }, null, 8, _hoisted_17))
                          : _createCommentVNode("", true),
                        (_ctx.rightTitle)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: _normalizeClass(_ctx.multiClasses.rightTitle),
                              style: _normalizeStyle(_ctx.stylesByRight)
                            }, _toDisplayString(_ctx.rightTitle), 7))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.hasRightTitleImage && _ctx.rightTitle)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(_ctx.multiClasses.rightTitle),
                        style: _normalizeStyle(_ctx.stylesByRight)
                      }, _toDisplayString(_ctx.rightTitle), 7))
                    : _createCommentVNode("", true)
                ], true),
                _renderSlot(_ctx.$slots, "rightLabel", {}, () => [
                  (_ctx.rightLabel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.multiClasses.rightLabel),
                        style: _normalizeStyle(_ctx.stylesByRight)
                      }, _toDisplayString(_ctx.rightLabel), 7))
                    : _createCommentVNode("", true)
                ], true)
              ])
            ], 2))
    ], 2),
    (_ctx.badge)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_ctx.badgeValue === -1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19))
            : _createCommentVNode("", true),
          (_ctx.badgeValue !== -1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.badgeValue), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasArrow || _ctx.badge)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(_ctx.baseLayoutClasses.cntAfter)
        }, [
          (_ctx.hasArrow)
            ? (_openBlock(), _createBlock(_component_t_icon, {
                key: 0,
                size: "xsmall",
                "icon-name": _ctx.iconName
              }, null, 8, ["icon-name"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.hasBottomBorder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21))
      : _createCommentVNode("", true)
  ], 16))
}